import baseEditForm from 'formiojs/components/_classes/component/Component.form';

import TextfieldEditData from 'formiojs/components/textfield/editForm/TextField.edit.data';
import TextfieldEditDisplay from 'formiojs/components/textfield/editForm/TextField.edit.display';
import TextfieldEditValidation from 'formiojs/components/textfield/editForm/TextField.edit.validation';

export default (...extend) => baseEditForm(
  [
    {
      key: 'display',
      components: TextfieldEditDisplay,
    },
    {
      key: 'data',
      components: TextfieldEditData,
    },
    {
      key: 'validation',
      components: TextfieldEditValidation,
    },
    {
      key: 'addons',
      ignore: true,
    },
    {
      label: 'Custom',
      key: 'custom',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Hide Custom Label',
          tooltip:
              'Hide the label (title, if no label) of this component. This allows you to show/hide the custom label when it is rendered.',
          key: 'hideCustomLabel',
          input: true,
        },
        {
          weight: 100,
          type: 'checkbox',
          label: 'Numbers Only',
          tooltip:
              'Only numbers can be used in this textfield',
          key: 'numbersOnly',
          input: true,
        },
        {
          weight: 150,
          type: 'checkbox',
          label: 'Is Phone Number',
          tooltip:
              'This field will be treated as a phone number field',
          key: 'isPhoneNumber',
          input: true,
        },
        {
          weight: 200,
          type: 'textfield',
          label: 'Prefix',
          placeholder: 'Mr.',
          key: 'prefix',
          input: true,
        },
        {
          weight: 250,
          type: 'textfield',
          label: 'Suffix',
          placeholder: 'KM',
          key: 'suffix',
          input: true,
        },
        {
          weight: 300,
          type: 'textfield',
          label: 'Session Storage Variable',
          tooltip: 'Variable used to update the default value of the textfield when the session storage is updated',
          key: 'sessionStorageVariable',
          input: true,
        },
        {
          weight: 350,
          type: 'checkbox',
          label: 'Use Session Storage',
          key: 'useSessionStorage',
          input: true,
        },
        {
          weight: 400,
          type: 'textfield',
          label: 'Tooltip Title',
          key: 'tooltipTitle',
          input: true,
        },
        {
          weight: 450,
          type: 'textfield',
          label: 'Character Limit (Integer Value)',
          key: 'characterLimit',
          input: true,
        },
      ],
    },
    {
      label: 'Review',
      key: 'review',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Use Custom Label',
          tooltip:
              'Use custom label for this component on the review page.',
          key: 'useReviewLabel',
          input: true,
        },
        {
          weight: 100,
          type: 'textfield',
          label: 'Review Page Label',
          key: 'reviewLabel',
          input: true,
        },
      ],
    },
  ],
  ...extend,
);
